<template>
    <div style="margin-left: 20px; margin-right: 20px; margin-top: 20px;">
      <back-btn />
        <v-card class="card--shadow">
        <v-card-title class="purple accent-4">
            <div class="subtitle-1 white--text">CI/HE Form</div>
        </v-card-title>
        <v-card class="card--shadow mb-2">
          <v-card-text>
            <div  v-if="patient" class="d-flex">
              <p v-if="patient.name" class="subtitle-1 patient-info">
                Name - {{ patient?patient.name:'' }}
              </p>
              <p
                v-if="patient.treatment_startdate != null"
                class="ml-3 subtitle-1 patient-info"
              >
                Code - {{ patient.reg_unique_code }}
              </p>
              <p
                v-if="patient.treatment_startdate != null"
                class="ml-3 subtitle-1 patient-info"
              >
        
              </p>
          </div>
          </v-card-text>
        </v-card>
        <v-card-text class="pt-4">
            <form-require-noti />
            <v-row>
            <v-col lg="3">
                <label>Date <require-sign /></label>
                <date-picker
                @clearDate="ciData.date = null"
                :validationMsg="handleFieldErrors($v.ciData.date)"
                :date="ciData.date"
                v-model="ciData.date"
                :min="minDate"
                :max="maxDate"
                />
            </v-col>
            <v-col lg="3">
              <label>Place <require-sign /></label>
              <v-text-field
                type="text"
                v-model="ciData.place"
                :error-messages="handleFieldErrors($v.ciData.place)"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col lg="3">
              <label>Type <require-sign /></label>
              <v-select
                :items="[
                  { id: '1', text: 'Community' },
                  { id: '2', text: 'Contact' },
                ]"
                v-model="ciData.type"
                :error-messages="handleFieldErrors($v.ciData.type)"
                item-text="text"
                item-value="id"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col lg="3">
                <label>Screening Person <require-sign /></label>
                <v-select
                :items="[
                    { id: '1', text: 'Volunteer' },
                    { id: '2', text: 'FO' },
                ]"
                v-model="ciData.screening_person"
                :error-messages="handleFieldErrors($v.ciData.screening_person)"
                item-text="text"
                item-value="id"
                dense
                outlined
                ></v-select>
            </v-col>
            <!-- <v-col lg="6">
              <label>Remark</label>
              <v-text-field
                v-model.trim="ciData.remark"
                type="text"
                dense
                filled
              ></v-text-field>
            </v-col> -->
          </v-row>
            <v-row  v-if="ciData.type == 2">
              <v-col lg="4">
                <label>Patient's Township </label>
                <v-select
                :items="townships"
                v-model="ciData.screening_township_id"
                item-text="name"
                item-value="id"
                dense
                outlined
                ></v-select>
            </v-col>
            <v-col lg="8">
                <v-card outlined class="outside-township-card pa-3" elevation="0">
                  <div class="d-flex align-center flex-wrap">
                    <div class="outside-township-label mr-3">
                      <v-icon small class="mr-1">mdi-map-marker-outline</v-icon>
                      Outside Township
                    </div>
                    <v-radio-group
                      v-model="ciData.outside_township"
                      class="outside-township-radio mt-0 flex-grow-0"
                      hide-details
                      dense
                      row
                    >
                      <v-radio label="No" value="1" color="teal accent-4"></v-radio>
                      <v-radio label="Yes" value="2" color="teal accent-4"></v-radio>
                    </v-radio-group>
                    <v-expand-transition>
                      <v-select
                        v-if="ciData.outside_township == 2"
                        :items="outside_townships"
                        v-model="ciData.outside_township_id"
                        item-text="name"
                        item-value="id"
                        label="Select township"
                        dense
                        outlined
                        clearable
                        placeholder="Choose township"
                        class="outside-township-select ml-4"
                        :error-messages="handleFieldErrors($v.ciData.outside_township_id)"
                        style="min-width: 200px;"
                      >
                        <template v-slot:label>
                          <span>Select township <require-sign v-if="ciData.outside_township == 2" /></span>
                        </template>
                      </v-select>
                    </v-expand-transition>
                  </div>
                </v-card>
            </v-col>
            </v-row>
            <v-row v-if="ciData.type == 2">
              <v-col md="4">
                  <label>Index Case No <require-sign /></label>
                  <v-text-field
                  v-model.trim="ciData.index_case_no"
                  :error-messages="handleFieldErrors($v.ciData.index_case_no)"
                  type="number"
                  outlined
                  dense
                  ></v-text-field>
              </v-col>
              <v-col md="4">
                  <label>Index Case Year<require-sign /> </label>
                  <v-text-field
                  v-model.trim="ciData.index_case_year"
                  :error-messages="handleFieldErrors($v.ciData.index_case_year)"
                  type="number"
                  outlined
                  dense
                  ></v-text-field>
              </v-col>
              <v-col md="4">
                  <label>Mono-Poly<require-sign /></label>
                  <v-select
                  v-model="ciData.index_case_monopoly"
                  :items="initialMonopoly"
                  dense
                  outlined
                ></v-select>
                 
              </v-col>
            </v-row>
            <v-row v-if="ciData.screening_person == 1">
              <v-col lg="12">
                <div class="section-divider mt-2 mb-2"></div>
              </v-col>
            </v-row>
            <v-row v-if="ciData.screening_person == 1">
              <v-col lg="6">
                <label>Supporting Township</label>
                <v-select
                  :items="townships"
                  v-model="ciData.supporting_township_id"
                  @change="handleSupportingTownship"
                  item-text="name"
                  item-value="id"
                  dense
                  outlined
                ></v-select>
              </v-col>
              <v-col lg="6">
                <label>Volunteers<require-sign /></label>
                <v-select
                  :items="volunteers"
                  v-model="ciData.volunteer_id"
                  item-value="id"
                  item-text="name"
                  :error-messages="handleFieldErrors($v.ciData.volunteer_id)"
                  dense
                  outlined
                >
                  <template v-slot:item="{ item }">
                    <span>{{ item.name ==null ? '':item.name}} / {{ item.code }}</span>
                  </template>
                  <template v-slot:selection="{ item }">
                    <span>{{ item.name ==null ? '':item.name}} / {{ item.code }}</span>
                  </template>
                </v-select>
              </v-col>
            
            </v-row>
             <!-- if community /type is 1 -->
             <div  v-if="ciData.type == 1">
              <!-- <hr class="small-hr"> -->
              <v-row>
                <v-col>
                  <div class="subtitle-1">For Community</div>
                </v-col>
                <v-col>
                  <v-card class="mr-3 card--shadow ml-auto mt-2" max-width="70px" >
                    <v-row justify="center">
                      <v-btn 
                      @click="addForm"
                        rounded
                        depressed
                        block
                        color="teal accent-4"
                        dark
                      >
                        <v-icon left dark >mdi-plus-circle-outline</v-icon> Add
                      </v-btn>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            
              <v-row v-for="(form, index) in community_forms" :key="index">
                <v-col lg="2">
                  <label>Name <require-sign /></label>
                  <v-text-field
                    type="text"
                    v-model="form.name"
                    outlined
                   
                    dense
                  ></v-text-field>
                </v-col>
                <v-col lg="1">
                  <label>Age <require-sign /></label>
                  <v-text-field
                    type="number"
                    v-model="form.age"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col>
                  <label>Sex</label>
                  <v-radio-group v-model="form.sex" class="my-2" hide-details dense row >
                      <v-radio label="Male" value="1"></v-radio>
                      <v-radio label="Female" value="2"></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col >
                  <label>Symptom Screening</label>
                    <v-radio-group v-model="form.community_symptom_screening" class="my-2" hide-details dense row >
                      <v-radio label="Yes" value="2"></v-radio>
                      <v-radio label="No" value="1"></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col >
                  <label>Refer</label>
                    <v-radio-group v-model="form.community_refer" class="my-2" hide-details dense row >
                      <v-radio label="Yes" value="2"></v-radio>
                      <v-radio label="No" value="1"></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col>
                  

                  <v-card class="mr-4 card--shadow mt-2 ml-auto" max-width="20px" >
                    <v-row justify="center">
                      <v-btn 
                      @click="removeForm(index)"
                        rounded
                        depressed
                        block
                        color="red accent-2"
                        dark
                      >
                      <v-icon> mdi-close-circle-outline </v-icon>
                      </v-btn>
                    </v-row>
                  </v-card>
                </v-col> <hr class="community-hr">
                
              </v-row>
              

              <v-card-actions >
                  <v-spacer></v-spacer>
                  <v-btn @click.prevent="emitCommunityData" :loading="loading" class="form-btn">
                  <v-icon left>mdi-chevron-right-circle-outline</v-icon>Submit
                  </v-btn>
              </v-card-actions>
            </div>

            <v-card-actions >
              <v-btn @click="addFamilyMember" v-if="showList && !loading && presumptiveData.length>=0 && ciData.type=='2'" :loading="loading" class="mt-2" outlined color="teal accent-4" dark >
              <v-icon left dark>mdi-plus-circle-outline</v-icon>Add Family Member
            </v-btn>
            <v-spacer></v-spacer>
           
            <v-btn @click.prevent="searchData" v-if="ciData.type=='2'" class="form-btn">
            <v-icon left>mdi mdi-magnify</v-icon>Search
            </v-btn>

            <!-- :loading="loading"  -->
        </v-card-actions>
        </v-card-text>
      
        <div v-if="showList && !loading " class="mt-5 px-4 pb-4" >
        
         <section v-if="presumptiveData.length == 0 && patient">
           <v-card
             elevation="0"
             color="pink accent-1"
             class="pa-2 d-flex justify-center bg-pink"
           >
           <p class="noti-text white--text">
               <v-icon class="white--text mr-1"
                 >mdi-clipboard-alert-outline</v-icon
               >Sorry, patient exists but no family members!
             </p>
           </v-card>
         </section>

         <section v-if="!patient && presumptiveData.length == 0">
           <v-card
             elevation="0"
             color="pink accent-1"
             class="pa-2 d-flex justify-center bg-pink"
           >
           <p class="noti-text white--text">
               <v-icon class="white--text mr-1"
                 >mdi-clipboard-alert-outline</v-icon
               >Sorry, patient does not exist!
             </p>
           </v-card>
         </section>
       
         <div v-else>
           <search-list v-if="showList && !loading && presumptiveData.length>0 && ciData.type=='2' " :updatedPresumptiveData="updatedPresumptiveData"
            />
         </div>
       </div>
       <div v-if="showList && !loading && presumptiveData.length>0 && ciData.type=='2'">
        <v-card-actions class="px-4 pb-4 mb-5">
            <v-spacer></v-spacer>
            <v-btn @click.prevent="emitData" :loading="loading" class="form-btn">
            <v-icon left>mdi-chevron-right-circle-outline</v-icon>Submit
            </v-btn>
        </v-card-actions>

      </div>
        </v-card>
        
    </div>
   
  </template>
  
  <script>
  import { required } from "vuelidate/lib/validators";
  import { ValidationMixin } from "../../mixins/ValidationMixin";
  import { limitDateMixin } from "../../mixins/limitDateMixin";
  import { mapState, mapActions } from "vuex";
  import FormRequireNoti from "@/components/notification/FormRequireNoti.vue";
  import RequireSign from "@/components/notification/RequireSign.vue";
  import DatePicker from "@/components/common/DatePicker.vue";
  import SearchList from "@/components/presumptive/CiList.vue";
  import BackBtn from "@/components/navigation/BackBtn.vue";

  export default {
    components: { 
      RequireSign, FormRequireNoti, DatePicker ,SearchList,BackBtn
    },
    mixins: [ValidationMixin, limitDateMixin],
    
    props: {
      ciData: {
        type: Object,
        default: function () {
          return {
            screening_person:'1',
            place:null,
            date: null,
            index_case_year: null,
            index_case_no: null,
            index_case_monopoly: 'No',
            //remark: null,
            symptom:[],
            presumptive_id:null,
            symptom_screening:null,
            screening_township_id:null,
            type:'2',
            supporting_township_id:null,
            volunteer_id:null,
            refer:null,
            outside_township:'1',
            outside_township_id:null,
            month:this.$route.params.month,
            year:this.$route.params.year,
            // name:null,
            // age:null,
            // sex:null,
            // community_symptom_screening:null,
            // community_refer:null,

          };
        },
      },
     
    },
    
    // data: () => ({
    //   initialMonopoly: ["No","Yes","SG"],
    //   showList: false,
    //   patient_not_exist:null,
    // }),
    data() {
    return {
      initialMonopoly: ["No","Yes","SG"],
      showList: false,
      patient_not_exist:null,
      community_forms: [
        { name: "", age: "", sex: "", community_symptom_screening: "2", community_refer: "1",township_id:this.$route.params.township_id } 
      ]
      };
    },
    beforeMount() {
      this.ciData.date = !this.ciData.date ? this.minDate : this.ciData.date;
    
    },
    validations() {
      return {
        ciData: {
          date: { required },
          screening_person: { required },
          type:{required},
         place:{required},

         index_case_year: {
            required: function () {
              return this.ciData.type === '2' ? required(this.ciData.index_case_year) : true;
            },
        },
        index_case_no: {
            required: function () {
              return this.ciData.type === '2' ? required(this.ciData.index_case_no) : true;
            },
        },
        volunteer_id: {
            required: function () {
              return this.ciData.screening_person === '1' ? required(this.ciData.volunteer_id) : true;
            },
        },
        outside_township_id: {
            required: function () {
              return this.ciData.outside_township === '2' ? required(this.ciData.outside_township_id) : true;
            },
        },
        },
       
      };
    },
    
    watch: {
      "ciData.outside_township"(val) {
        if (val === "2") {
          const townshipId = this.ciData.screening_township_id || this.$route.params.township_id;
          if (townshipId) {
            this.$store.dispatch("Township/getOutsideTownships", townshipId);
          }
        } else {
          this.ciData.outside_township_id = null;
        }
      },
      "ciData.screening_township_id"(val) {
        if (val && this.ciData.outside_township === "2") {
          this.$store.dispatch("Township/getOutsideTownships", val);
        }
      },
    },
    methods: {
      ...mapActions("Township", ["getAllTownships", "getOutsideTownships"]),
      handleSupportingTownship(id) {
        this.$store.dispatch("Volunteer/getVolunteerByTwnId", id);
      },
      addFamilyMember() {
      if (this.patient) {
        this.$router.push({
          name: "PatientFamily",
          params: {
            patient_id: this.patient.id,
          },
        });
      } else {
        this.$toast.error("Patient not found");
      }
    },
      searchData() {
        
        this.$v.$touch();
        if (!this.$v.$invalid) {
          let data = {
            // id: this.ciData.id,
            type: this.ciData.type,
            place: this.ciData.place,
            index_case_monopoly: this.ciData.index_case_monopoly === "Yes" ? 2 : (this.ciData.index_case_monopoly === "No" ? 1 : (this.ciData.index_case_monopoly === "SG" ? 3 : 1)),
            index_case_no: this.ciData.index_case_no,
            index_case_year: this.ciData.index_case_year,
            township_id: this.ciData.screening_township_id,
            case_found_at: 3,
            screening_township_id: this.ciData.screening_township_id,
            supporting_township_id: this.ciData.supporting_township_id,
            volunteer_id: this.ciData.volunteer_id,
            outside_township: this.ciData.outside_township,
            ...(this.ciData.outside_township_id != null && { outside_township_id: this.ciData.outside_township_id }),
          };
          this.showList = false;
          this.$store.dispatch("Patient/getByIndexCode", data).then(() => {
            
            this.$store.dispatch("Presumptive/searchByIndexCode", data)
              .then(() => {
                this.showList = true;
              });
          }) .catch((error) => {
                console.error("Error in Patient/getByIndexCode:", error);
                this.message = "An error occurred while fetching patient data.";
              });
         
        }
      },
     
      emitData() {
      
        this.$v.$touch();
        if (!this.$v.$invalid) {
       
        this.updatedPresumptiveData.patient_id= this.patient?this.patient.id :null;
        this.updatedPresumptiveData.township_id= this.$route.params.township_id;

        console.log(this.updatedPresumptiveData);

          this.$store.dispatch("Ci/create", this.updatedPresumptiveData).then(() => {
         
          this.$router.push(
          `/ci-list/${this.$route.params.month}/${this.$route.params.year}/${this.$route.params.township_id}`
        );
          
        });
      
        }
      },
      addForm() {
      this.community_forms.push({ name: "", age: "", sex: "", community_symptom_screening: "2", community_refer: "1" });
    },
    removeForm(index) {
      this.community_forms.splice(index, 1);
    },
    emitCommunityData(){

      this.$v.$touch();
        if (!this.$v.$invalid) {
            const payload = {
            ciData: this.ciData,
            community_forms: this.community_forms
            };

            this.$store.dispatch("Ci/create", payload).then(() => {
            
                this.$router.push(
                `/ci-list/${this.$route.params.month}/${this.$route.params.year}/${this.$route.params.township_id}`
              );
                
              });
            
          }
    }
      
    },
    computed: {
      ...mapState("Loading", ["loading"]),
      ...mapState("Volunteer", ["volunteers"]),
      ...mapState("HE", ["townshipVolunteers"]),
      ...mapState("Admin", ["admin"]),
      ...mapState("InfoData", ["mdrTbRegs", "typeOfTBOpt"]),
      ...mapState("Township", ["townships", "outside_townships"]),
      ...mapState("Presumptive", ["presumptiveData"]),
      ...mapState("Patient", ["patient"]),
      

      updatedPresumptiveData() {
        return this.presumptiveData.map(item => {
          // Add a new value to each item
          return {
            ...item,
              ci_date: this.ciData.date,
              screening_person:this.ciData.screening_person,
              type:this.ciData.type,
              index_case_no:this.ciData.index_case_no,
              index_case_year:this.ciData.index_case_year,
              index_case_monopoly:this.ciData.index_case_monopoly,
              township_id:this.$route.params.township_id,
              screening_township_id:this.ciData.screening_township_id,
              symptom_screening:'2',
              refer:'1',
              place:this.ciData.place,
              month:this.$route.params.month,
              year:this.$route.params.year,
              supporting_township_id:this.ciData.supporting_township_id,
              volunteer_id:this.ciData.volunteer_id,
              outside_township: this.ciData.outside_township,
              outside_township_id: this.ciData.outside_township_id,
              // remark:this.ciData.remark,
          };
        });
      },
      
    },
    created() {
      this.ciData.screening_township_id=!this.ciData.screening_township_id? Number(this.$route.params.township_id):this.ciData.screening_township_id;
      this.ciData.supporting_township_id=!this.ciData.supporting_township_id? Number(this.$route.params.township_id):this.ciData.screening_township_id;
      this.getAllTownships();
      if (this.ciData.outside_township === "2" && this.ciData.screening_township_id) {
        this.getOutsideTownships(this.ciData.screening_township_id);
      }

      this.$store.dispatch(
      "Volunteer/getVolunteerByTwnId",
      this.$route.params.township_id
    );
    },
  };
  </script>
  
  <style scoped>
  .outside-township-card {
    border-radius: 8px;
    border-color: rgba(0, 0, 0, 0.12);
    background-color: rgba(0, 150, 136, 0.04);
  }

  .outside-township-label {
    font-size: 0.875rem;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.6);
  }

  .section-divider {
    height: 1px;
    background: linear-gradient(
      to right,
      transparent,
      rgba(0, 0, 0, 0.12) 20%,
      rgba(0, 0, 0, 0.12) 80%,
      transparent
    );
  }

  .community-hr {
    width: 1500px;
    height: 0.5px;
    background-color: rgba(0, 0, 0, 0.2); /* Light gray */
    border: none;
    margin: 5px auto;
  }

.small-hr {
    width: 800px;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.2); /* Light gray */
    border: none;
    margin: 5px auto;
  }
</style>
  
  
  